import React from "react";
import Box from "@mui/material/Box";

const ImageCounter = ({ index, total }) => {
  if (!total) return null;

  return (
    <Box
      position="absolute"
      borderRadius="40%"
      fontSize="16px"
      right={20}
      top={20}
      px="6px"
      py="4px"
      zIndex={1}
      color="white"
      bgcolor="rgb(0, 0, 0, 0.5)"
    >
      {index + 1} / {total}
    </Box>
  );
};

export default ImageCounter;

